var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{attrs:{"redirectWithLoginFailed":true},on:{"loggedIn":_vm.onLoggedIn}},[_c('div',{staticClass:"wrap-payment"},[(_vm.user)?_c('ModulePayment',{attrs:{"user":_vm.user}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }